module.exports = __webpack_public_path__ + "static/media/production-white.1aada7c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/production-white.svg
// module id = 795
// module chunks = 0